<app-sales-credit-number [creditNumber]="data().number" [data]="data()" *ngIf="categoryCode !== 'kredicash' "></app-sales-credit-number>

<ng-container *ngIf="request">
  <div class="container section__creditResume h-full">
    <div class="wrapper">
      <div class="sectionContainer fadeinright animation-duration-200">
        <article class="pb-40">
          <div class="mainInfo mb-30">
            <i class="mainIcon mainIcon--amount">
              <app-credit-resume-icon></app-credit-resume-icon>
            </i>
            <h1>¡Excelente!</h1>
            <p>
              {{ 'Mira cómo quedaría tu crédito:' | termReplace }}
            </p>
          </div>

          <div class="resumeBox">
            <div class="product mb-20">
              <div class="subtitle mb-10">
                <h2>Producto seleccionado</h2>
              </div>

              <div class="product__item">
                <div class="productListItem__cont">
                  <div class="img">
                    <img [src]="request?.category?.icon_url || extractCategoryIcon(request?.category_id)" [alt]="request.product?.name">
                  </div>
                  <div class="info">
                    <div class="title">
                      <h3>
                        {{request.product?.name}}
                      </h3>
                    </div>
                    <div class="main-price" *ngIf=!macroFlowService.isExperanzaFlow(this.flowCode)>
                      <p>{{getMainProductAmount() | currency}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="additionalProductSummary mb-15" *ngIf="hasAdditionalProduct()">
              <div class="separator">
                <i>
                  <app-circle-full-plus-icon></app-circle-full-plus-icon>
                </i>
              </div>

              <div class="subtitle mb-10">
                <h2>Producto adicional</h2>
              </div>

              <div class="additionalProductSummary__item mb-15">
                <div class="additionalProductSummary__itemCont">
                  <div class="category">
                    <span>{{ getAdditionalProduct()?.category }}</span>
                  </div>

                  <div class="info">
                    <h3>{{ getAdditionalProduct()?.name }}</h3>
                    <span>{{ getAdditionalProductNetAmount() | currency}}</span>
                  </div>

                  <div class="details">
                    <p><span>Monto: <strong>{{ getAdditionalProduct()?.amount | currency}}</strong></span> <span class="circle"></span> <span>Descuento: <strong>{{ getAdditionalProduct()?.discount_pct }}%</strong></span></p>
                  </div>
                </div>
              </div>

              <div class="additionalProductSummary__breakdown">
                <div class="title">
                  <i>
                    <app-money-white-icon></app-money-white-icon>
                  </i>
                  <h3>Detalle del crédito</h3>
                </div>

                <div class="summary">
                  <ul>
                    <li>
                      <span class="text">Subtotal productos</span>
                      <span class="value">{{ getProductsSubtotal() | currency}}</span>
                    </li>
                    <li>
                      <span class="text">Abono</span>
                      <span class="value">- {{ getInstallmentAmount() | currency}}</span>
                    </li>
                    <li class="highlight">
                      <span class="text">Monto financiado total</span>
                      <span class="value">{{ getFinancedTotalAmount() | currency}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="credit">
              <p *ngIf=!macroFlowService.isExperanzaFlow(this.flowCode)>Vas a dar un abono de <strong>{{request.quotes.installment.selected | currency}}</strong> y pagarás <strong>{{ request.quotes.quota.selected | currency}} {{frecuencyText(request.quotes.frecuency)}}</strong> durante <strong>{{ request.quotes.quota.quantity}} cuotas</strong>.</p>

              <p *ngIf=macroFlowService.isExperanzaFlow(this.flowCode)>Pagarás <strong>{{request.quotes.quota.selected | currency}}</strong> mensuales durante <strong>{{ request.quotes.quota.quantity}} cuotas</strong> descontado de tu boleta de pago de la ONP.</p>
            </div>
          </div>
        </article>

        <footer>
          <div class="footer__content stacked">
            <button pButton pRipple label="Cambiar producto" icon="pi pi-angle-left" iconPos="left" class="p-button-secondary p-button-raised p-button-rounded n-background" (click)="onGotoStep(request?.category_id, SalesWorkflowSteps['select-product'])"></button>

            <button pButton pRipple label="Si, estoy de acuerdo" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onNextStep()"></button>

            <!-- TODO: pendiente retomar, con los pasos este boton tiene dificultad de operacion
            <div class="footer__float">
              <p-button label="Me gustaría probar otra configuración" icon="pi pi-angle-left" iconPos="left" [text]="true" [plain]="true" (onClick)="onGotoStep(SalesWorkflowSteps['select-quota'])"></p-button>
            </div>-->
          </div>
        </footer>
      </div>
    </div>
  </div>
</ng-container>
